import { render, staticRenderFns } from "./ChronologyRegister.vue?vue&type=template&id=97c30d20&"
import script from "./ChronologyRegister.vue?vue&type=script&lang=js&"
export * from "./ChronologyRegister.vue?vue&type=script&lang=js&"
import style0 from "./ChronologyRegister.vue?vue&type=style&index=0&id=97c30d20&prod&lang=scss&"
import style1 from "./ChronologyRegister.vue?vue&type=style&index=1&id=97c30d20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports